<template>
  <div class="specialOffer-container">
    <w-navbar
            :icon="'iconchevron-left'"
            nav_title="选择优惠券"
            @mobileLeftBtn="leftBtnClick"
            v-show="iosOrAndroidShow"
    >
      <span slot="rightContent" @click="rightBtnClick">兑换优惠券</span>"
    </w-navbar>
    <w-no-result v-if="coupons.length == 0" text="没有可选择的优惠券"></w-no-result>
    <!-- {{specialOfferList}}
    {{activeCoupon}}
    {{activeObj}} -->
    <div class="specialOffer-list">
      <div v-for="item in coupons" :class="['specialOffer-item', item.id === useCoupon.id ? 'active' : '']" @click="changeCoupon(item)">
        <div class="coupon-money" v-if="!item.discount">
          ￥<span class="cent">{{item.cent / 100}}</span>
        </div>
        <div class="coupon-money" v-else>
          <span class="cent">{{item.discount * 10}}</span>折
        </div>
        <div class="coupon-message">
          <span class="coupon-name">{{item.name}}</span>
          <span class="expiry">{{item.expiry | timeFilter('YYYY-MM-DD')}}</span>
        </div>
      </div>
    </div>
    <div class="member-footer" v-show="coupons.length > 0">
      <div class="submit-btn">
        <div class="discounts">优惠 ￥ {{money}}</div>
        <div class="confirm" @click="leftBtnClick">确认</div>
      </div>
    </div>
    <w-scale :scaleShow="scaleShow" :top="32">
      <div class="special-content" slot="content">
        <div class="special-title">兑换优惠券</div>
        <div class="special-contents">
          <p class="content-tip">请输入优惠券兑换码</p>
          <input type="text" class="code-input" placeholder="" v-model="code">
        </div>
        <div class="special-footer">
          <div class="item" @click="operation(false)">取消</div>
          <div class="item" @click="operation(true)">确定</div>
        </div>
      </div>
    </w-scale>
  </div>
</template>

<script>
  import WNavbar from '@/components/global/w-navbar';
  import {envMixin, loginMixin, WxMixin} from '@/assets/js/mixin/global';
  import {componentsMixin} from '../../../assets/js/mixin/components'
  import {userMixin} from '@/assets/js/mixin/user';
  import api from '../../../api/api-list'
  import WScale from '@/components/global/w-scale'
  import WNoResult from '../../../components/global/w-no-result'

  export default {
    name: "special-offer",
    components: {
      WNavbar,
      WScale,
      WNoResult
    },
    mixins: [envMixin, loginMixin, WxMixin, componentsMixin, userMixin],
    props: {
      specialOfferList: {
        type: Array,
        default: []
      },
      activeCoupon: {
        type: Object,
        default: {}
      },
      activeObj: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        code: '',
        coupons: [],
        useCoupon:{},
        scaleShow: false
      }
    },
    async mounted() {
      this.coupons = this.specialOfferList
      this.useCoupon = this.activeCoupon
    },
    methods: {
      // 选择使用的优惠券
      changeCoupon(obj) {
        if (this.useCoupon.id != obj.id) {
          this.useCoupon = obj
        }else {
          this.useCoupon = {}
        }
      },
      // 操作弹窗
      async operation(type) {
        if (type) {
          let type = this.activeObj.type
          if(type === '终身会员Plus'){
            type = '终身会员'
          }
          let res = await this.$api.user.setSpecialOffers(this.cvAccountToken, {coupon_plan: type, partner: this.code})
          if (res.code === 1000) {
            this.coupons = res.data.coupons.filter(coupon => coupon.usable === true)
            this.code = ""
            // 终身会员提示
            if (res.data.code_kind === 'member' && res.data.message.indexOf('30000') > -1) {
              this.showToast("恭喜成为超级简历终身会员！", 1500)
              // 会员天数提示
            }else if (res.data.code_kind === 'member') {
              this.showToast(res.data.message, 1500)
              setTimeout(()=>{
                if (res.data.message === '恭喜成为超级简历终身会员！') {
                  this.$db.ls.set('member_isSuper',true)
                }else {
                  this.$db.ls.set('member_isSuper',false)
                }
                if(type === '终身会员Plus'){
                  this.$db.ls.set('member_isSuperPlus', true)
                }
                // 终身会员Plus
                this.$router.push("/pay/wechat/success")
              },1500)
              // 金额和折扣优惠券提示
            }else {
              this.showToast(res.data.message, 1500)
            }
          } else {
            this.showToast(res.data ? res.data.error : res.message, 1500)
          }
        }
        this.scaleShow = false
        this.code = ''
      },
      // 兑换优惠券弹窗显示
      rightBtnClick() {
        this.scaleShow = true
      },
      // 返回会员购买页
      leftBtnClick() {
        this.$emit('closeOffer',{coupons:this.coupons,activeCoupon:this.useCoupon})
      }
    },
    computed: {
      money() {
        let price = parseInt(this.activeObj.cent)
        let cent = this.useCoupon.cent
        let discount = this.useCoupon.discount
        if (cent) {
          return (cent / 100).toFixed(2)
        }else if (discount) {
          return (price * (1 - discount)).toFixed(2)
        }else {
          return 0
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .special-content{
    width: 311px;
    height: 203px;
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    .special-title {
      margin-top: 24px;
      font-size: 16px;
      color: #404040;
      font-weight: bold;
      text-align: center;
    }
    .special-contents {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 16px;

      .content-tip {
        width: 100%;
        text-align: center;
        /*margin-top: 16px;*/
        font-size: 14px;
        color: #9c9c9c;
      }

      .code-input {
        width: 263px;
        height: 36px;
        margin-top: 8px;
        border-color: #ececec;
        &::placeholder{
          color: #9c9c9c;
        }
      }
    }
    .special-footer{
      width: 100%;
      height: 62px;
      display: flex;
      position: absolute;
      left: 0;
      bottom: 0;
      border-top: 1px solid #f4f4f4;
      .item{
        width: 50%;
        height: 100%;
        box-sizing: border-box;
        line-height: 62px;
        text-align: center;
        font-size: 16px;
        color: #404040;
        &:first-child{
          border-right: 1px solid #f4f4f4;
          color: #9c9c9c;
        }
      }
    }
  }
  .specialOffer-container {
    width: 100%;
    height: 100vh;
    overflow: auto;
    position: absolute;
    left: 0;
    top: 0;
    background-color: #fff;
    z-index: 99;

    .member-footer{
      width: 100%;
      height: 78px;
      position: fixed;
      left: 0;
      bottom: 0;
      background: url("https://files.wondercv.com/m/buyMember/member-footer.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 100;
      .submit-btn{
        width: 329px;
        height: 46px;
        border-radius: 23px;
        /*background-color: #ff6644;*/
        cursor: pointer;
        /*text-align: center;*/
        line-height: 46px;
        color: #fff;
        font-size: 16px;
        display: flex;
        overflow: hidden;
        .discounts{
          font-size: 16px;
          width: calc(100% - 129px);
          box-sizing: border-box;
          padding-left: 24px;
          background-color: #525568;
          /*font-weight: 400;*/
        }
        .confirm{
          width: 129px;
          height: 100%;
          text-align: center;
          background: linear-gradient(to right, #ff8436, #ff4f4c);
        }
      }
    }

    .specialOffer-list {
      width: 100%;
      height: auto;
      padding: 68px 24px 92px;

      .specialOffer-item {
        width: 327px;
        height: 72px;
        margin-top: 20px;
        padding: 16px 0;
        display: flex;
        box-sizing: border-box;
        background: url("https://files.wondercv.com/m/buyMember/coupon_normal.png") no-repeat;
        background-size: 100% 100%;

        .coupon-money{
          width: 80px;
          height: 100%;
          line-height: 40px;
          text-align: center;
          color: #FF6644;
          font-size: 12px;
          .cent{
            font-size: 16px;
          }
        }

        .coupon-message{
          width: 279px;
          height: 100%;
          padding-left: 34px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .coupon-name{
            font-size: 14px;
          }
          .expiry{
            font-size: 12px;
            color: #9c9c9c;
          }
        }

        &:first-child {
          margin-top: 0;
        }
      }
      .active{
        background: url("https://files.wondercv.com/m/buyMember/coupon_active.png") no-repeat;
        background-size: 100% 100%;
        color: #FF6644;
        .coupon-message{
          .expiry{
            color: #ff6644;
          }
        }
      }
    }
  }
</style>